var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Chip, Stack } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { FFrDashboard } from "../fieldFailureReport.dashBoard";
export var AsmDashBoard = function () {
    var obj = {
        Organizations: [{
                "name": "Product",
                "count": 639
            }, {
                "name": "Part",
                "count": 2728
            }, {
                "name": "labour",
                "count": 188
            }],
        Products: [{
                "name": "Product",
                "count": 639
            }, {
                "name": "Part",
                "count": 3728
            }],
        Services: [{
                "name": "Product",
                "count": 639
            }, {
                "name": "Part",
                "count": 3728
            }],
        xys: [{
                "name": "Product",
                "count": 639
            }, {
                "name": "Part",
                "count": 3728
            }]
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'space-between',
            gap: '16px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 6,
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    spacing: 0,
                    width: 'auto',
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    position: 'static',
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 0,
                            sx: {
                                padding: '6px',
                                bgcolor: 'secondary.100',
                                borderColor: 'secondary.200'
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Motorcycle',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$PaidAmount;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Motorcycle', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$PaidAmount = state === null || state === void 0 ? void 0 : state.PaidAmount) !== null && _state$PaidAmount !== void 0 ? _state$PaidAmount : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'ProBiking',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ExpenseAmount;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['ProBiking', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$ExpenseAmount = state === null || state === void 0 ? void 0 : state.ExpenseAmount) !== null && _state$ExpenseAmount !== void 0 ? _state$ExpenseAmount : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'CommercialVehicle',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ClaimAmount;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Commercial Vehicle', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$ClaimAmount = state === null || state === void 0 ? void 0 : state.ClaimAmount) !== null && _state$ClaimAmount !== void 0 ? _state$ClaimAmount : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Urbanite',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ClaimAmount2;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Urbanite', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$ClaimAmount2 = state === null || state === void 0 ? void 0 : state.ClaimAmount) !== null && _state$ClaimAmount2 !== void 0 ? _state$ClaimAmount2 : 0
                                                })]
                                        };
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    value: null,
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    alignItems: "center",
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "Date range",
                            children: '5 Jan, 2025 to 10 Feb, 2025',
                            columnSize: 0,
                            labelTypographyProps: {
                                fontSize: "sm",
                                fontWeight: "medium"
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: "",
                            label: "",
                            valueExpr: "id",
                            displayExpr: "Name",
                            columnSize: 5
                        }]
                }]
        }, {
            type: FormItemTypes.Stack,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    columnSize: 12,
                    children: /*#__PURE__*/ React.createElement(FFrDashboard, {
                        dashboardCount: obj
                    })
                }]
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            bgcolor: 'secondary.50'
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
        // mode={id ? "edit" : "add"}
        ,
        gridProps: {
            spacing: 0
        },
        formProps: {
            p: 2
        }
        // onClose={() => navigate("/pdiCheck")}
    }));
};
